import { createStore } from "vuex";
import login from './modules/login'
import sidebar from './modules/sidebar'
import account from './modules/account'
import tasks from './modules/tasks'
import historytasks from './modules/historytasks'
import documents from './modules/documents'


const debug = process.env.NODE_ENV !== 'production'

export default createStore(
    {
        modules: {
            login,
            sidebar,
            account,
            tasks,
            historytasks,
            documents
        },
        strict: debug,
        //plugins: debug ? [createLogger()] : []
    }
)